var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "text-align": "center" } },
    [
      !_vm.user || !_vm.user.displayName
        ? _c("v-container", [
            !_vm.user || !_vm.user.displayName
              ? _c(
                  "div",
                  { staticClass: "title primary--text darken-1--text" },
                  [_vm._v("\n      Click the Sign-in button to Login\n  ")]
                )
              : _vm._e()
          ])
        : _c(
            "v-container",
            [
              _vm.user && !_vm.authorized
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        { staticClass: "title primary--text darken-1--text" },
                        [
                          _vm._v(
                            "\n            Please use your Jahnel Group email address to sign in.\n            "
                          ),
                          _c("br"),
                          _c("br")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticStyle: { cursor: "pointer" },
                          attrs: { to: "/LandingPage", tag: "span" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary darken-2",
                              on: { click: _vm.signout }
                            },
                            [
                              _vm._v(
                                "\n            Switch Accounts\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.authorized ? _c("this-month") : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54f74f74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54f74f74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPage.vue
// module id = SF+z
// module chunks = 1